<template>
	<div class="add-machine-advert-group">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="machineAdvertGroup.id ? 'Edit Label Ads' : 'New Label Ads'"
			:visible.sync="dialogMachineAdvertGroup"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="machineAdvertGroup"
					label-width="90px"
					:model="machineAdvertGroup">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item
								:label="$t('addMachineAdvertGroup.adTeamId')"
								prop="adTeamId">
								<el-select
									v-model="machineAdvertGroup.adTeamId"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('addMachineAdvertGroup.pAdvertGroupId')">
									<el-option
										v-for="item in advertGroupList"
										:key="item.id"
										:label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item
								label="Label grouping"
								prop="userEquipmentLabelTeamId">
								<el-select
									v-model="machineAdvertGroup.userEquipmentLabelTeamId"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									placeholder="Please select the label group">
									<el-option
										v-for="item in userMachineGroupList"
										:key="item.id"
										:label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item
								:label="$t('addMachineAdvertGroup.notes')"
								prop="notes">
								<el-input
									v-model="machineAdvertGroup.notes"
									type="textarea"
									:rows="4"
									:placeholder="$t('addMachineAdvertGroup.pRemarks')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('machineAdvertGroup')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "AddMachineAdvertGroup",
	props: {
		machineAdvertGroup: Object,
		advertGroupList: Array,
		userMachineGroupList: Array,
		dialogMachineAdvertGroup: Boolean,
	},
	data() {
		return {
			labelPosition: "top",
			clear: false,
			rules: {
				adTeamId: [
					{
						required: true,
						message: this.$t("addMachineAdvertGroup.pAdvertGroupId"),
						trigger: "blur",
					},
				],
				userEquipmentLabelTeamId: [
					{
						required: true,
						message: this.$t(
							"message.addMachineAdvertGroup.pUserMachineGroupId"
						),
						trigger: "blur",
					},
				],
			},
			loadingForm: false,
		};
	},
	methods: {
		// 关闭弹窗
		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},
		closeDialog() {
			this.clearValidate("machineAdvertGroup");
			if (this.machineAdvertGroup.id) {
				this.$toolUtil.clearForm(this.machineAdvertGroup);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.machineAdvertGroup);
				}
			}
			this.cancel("");
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.MachineAdvertGroupLabel.insert;
					let method = this.$method.post;
					if (this.machineAdvertGroup.id) {
						url = this.$url.MachineAdvertGroupLabel.update;
						method = this.$method.put;
					}
					this.$api
						.request(url, method, this.machineAdvertGroup)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.cancel(this.machineAdvertGroup.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				}
			});
		},
		// 清除表单校验
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		openDialog() {},
	},
};
</script>

<style scoped></style>
